import React from "react";
import { observer } from "mobx-react";
import {
  Switch as SwitchContext,
  Redirect,
  withRouter,
  RouteComponentProps,
} from "react-router-dom";

import AuthStore from "stores/AuthStore";

import Container from "components/Layout/Container";
import Header from "components/Layout/Header";
import PublishButton from "components/PublishButton";

import Tips from "./Tips";

import { PrivateRoute } from "navigation/Switch";

import ROUTES from "navigation/routes";

type Props = RouteComponentProps & {};

@observer
class ContentTips extends React.Component<Props> {
  render() {
    return (
      <Container header={<Header controls={<PublishButton />} />}>
        <SwitchContext>
          <PrivateRoute
            path={ROUTES.CONTENT_TIPS}
            component={Tips}
            allowAccess={AuthStore.isAuthorized}
            redirectTo={ROUTES.CONTENT_TIPS}
            exact
          />

          <Redirect to={ROUTES.CONTENT_TIPS} />
        </SwitchContext>
      </Container>
    );
  }
}

export default withRouter(ContentTips);
